import Vue from 'vue'
import Router from 'vue-router'
import Nav from './components/Nav.vue'
// introduction
import Introduction from './views/introduction/Introduction.vue'
import Principles from './views/introduction/Principles.vue'
import Use from './views/introduction/Use.vue'
import Downloads from './views/introduction/Downloads.vue'
import Tokens from './views/introduction/Tokens.vue'

// foundations
import Colours from './views/foundations/Colours.vue'
import Typography from './views/foundations/Typography.vue'
import Iconography from './views/foundations/Iconography.vue'
import Grids from './views/foundations/Grids.vue'

// components
import Accordions from './views/components/Accordions.vue'
import Alerts from './views/components/Alerts.vue'
import Notifications from './views/components/Notifications.vue'
import Avatars from './views/components/Avatars.vue'
import Buttons from './views/components/Buttons.vue'
import Badges from './views/components/Badges.vue'
import Breadcrumb from './views/components/Breadcrumb.vue'
import Cards from './views/components/Cards.vue'
import Comments from './views/components/Comments.vue'
import Dropdowns from './views/components/Dropdowns.vue'
import Lists from './views/components/Lists.vue'
import Modals from './views/components/Modals.vue'
import Paginations from './views/components/Paginations.vue'
import Panels from './views/components/Panels.vue'
import Popver from './views/components/Popver.vue'
import Search from './views/components/Search.vue'
import Scroll from './views/components/Scroll.vue'
import Stepper from './views/components/Stepper.vue'
import Tables from './views/components/Tables.vue'
import TableOfContent from './views/components/TableOfContent.vue'
import Tabs from './views/components/Tabs.vue'
import Tags from './views/components/Tags.vue'
import Timeline from './views/components/Timeline.vue'
import Toasts from './views/components/Toasts.vue'
import Tooltips from './views/components/Tooltips.vue'
// states
import Loading from './views/states/Loading.vue'
import Message from './views/states/Message.vue'
import Empty from './views/states/Empty.vue'
// templates
import Adaptive from './views/templates/Adaptive.vue'
import Fluid from './views/templates/Fluid.vue'

//form
import FormLayout from './views/forms/FormLayout.vue'
import Inputs from './views/forms/Inputs.vue'
import Toggles from './views/forms/Toggles.vue'
import Checkboxes from './views/forms/Checkboxes.vue'
import Radios from './views/forms/Radios.vue'
import Ratings from './views/forms/Ratings.vue'
import Buckets from './views/forms/Buckets.vue'

//pages
import Landmarks from './views/page/Landmarks.vue'

// utilities
import Borders from './views/utilities/Borders.vue'
import Colors from './views/utilities/Colors.vue'
import Display from './views/utilities/Display.vue'
import Flex from './views/utilities/Flex.vue'
import Grid from './views/utilities/Grid.vue'
import Misc from './views/utilities/Misc.vue'
import Sizing from './views/utilities/Sizing.vue'
import Spacing from './views/utilities/Spacing.vue'
import Text from './views/utilities/Text.vue'

// accessibility
import General from './views/accessibility/General.vue'
import Checklist from './views/accessibility/Checklist.vue'
import Wcag from './views/accessibility/Wcag.vue'
import Tools from './views/accessibility/Tools.vue'
import Aria from './views/accessibility/Aria.vue'
import Utility from './views/accessibility/Utility.vue'
import Form from './views/accessibility/Form.vue'

Vue.use(Router)

let createRoutes = (prefix = '', components) => {
  let routes = []
  let route;
  components.forEach(component => {
    if (component.name) {
      // Vue component
      route = {
        path: prefix + '/' + component.name,
        name: component.name,
        component,
      }
      routes.push(route)
    } else if (component.routeComponent) {
      // Route with nested named views
      // Create object for nested named views
      let nestedRoutes = {}
      Object.keys(component.components).forEach(nestedRoute => {
        nestedRoutes[nestedRoute] = component.components[nestedRoute]
      })
      nestedRoutes.default = component.routeComponent
      route = {
        path: prefix + '/' + component.routeComponent.name,
        name: component.routeComponent.name,
        components: nestedRoutes
      }
      routes.push(route)
    } else if (Array.isArray(component)) {
      // Route with prefix
      let subPrefix = component[0]
      let subComponents = component[1]
      let subRoutes = createRoutes(prefix + '/' + subPrefix, subComponents)
      subRoutes.forEach(subRoute => {
        routes.push(subRoute)
      })
    } else {
      throw new Error('Invalid object')
    }
  })
  // Catch undefined route
  // Base routes loop
  if (prefix === '') {
    route = {
      path: '*',
      component: Introduction,
    }
    routes.push(route)
  }

  return routes
}

let components = [
  Introduction,
  Principles,
  Use,
  Downloads,
  Tokens,
  [
    'foundations',
    [
      Colours,
      Typography,
      {
        routeComponent: Iconography,
        components: {
          nav: Nav
        }
      },
      Grids
    ]
  ],
  [
    'components',
    [
      Accordions,
      Alerts,
      Notifications,
      Avatars,
      Buttons,
      Badges,
      Breadcrumb,
      Cards,
      Comments,
      Dropdowns,
      Lists,
      Modals,
      Paginations,
      Panels,
      Popver,
      Search,
      Scroll,
      Stepper,
      Tables,
      TableOfContent,
      Tabs,
      Tags,
      Timeline,
      Toasts,
      Tooltips
    ]
  ],
  [
    'states',
    [
      Loading,
      Empty,
      Message
    ]
  ],
  [
    'forms',
    [
      Checkboxes,
      Inputs,
      Radios,
      Ratings,
      Toggles,
      Buckets,
      FormLayout
    ]
  ],
  [
    'templates',
    [
      Adaptive,
      Fluid
    ]
  ],
  [
    'page',
    [
      Landmarks
    ]
  ],
  [
    'utilities',
    [
      Borders,
      Colors,
      Display,
      Flex,
      Grid,
      Misc,
      Sizing,
      Spacing,
      Text
    ]
  ],
  [
    'accessibility',
    [ 
      General,
      Checklist,
      Wcag,
      Tools, 
      Aria,
      Form,
      Utility
    ]
  ]
]

let routes = createRoutes(undefined, components)
// Redirect '/' to introduction
const route = {
  path: '/',
  redirect: {
    name: 'introduction',
  }
}
routes.unshift(route)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
